import Button from "../../components/button";
import Modal from "../../components/modal";
import Headline5 from "../../components/headings/Headline5";

function DeleteModal(props: any) {

  const section = props.section
    
  const onClose = () => {
    props.onClose()
  }

  const handleSubmit = () => {
    props.onSubmit(section)
  }
  
  return(
    <Modal title={" "} onClose={onClose} size="small">
      <Headline5>Are you sure to delete?</Headline5>
      <p>Deleting this field will permanently delete this data from your profile!</p>
      <div className="popupAction">
        <Button onClick={onClose} type="submit" variant="cancel" size="small">Cancel</Button>
        <Button onClick={handleSubmit} type="submit" variant="delete" size="small">Delete</Button>
      </div>
    </Modal>
  )
}
export default DeleteModal